import TriMoji from "./TriMoji";

const HappyCompliment = TriMoji({ top: "🤲", mid: "✨", bottom: "😎️" });

export default HappyCompliment;
